import axios from 'axios'
import { ACCOR_SECURE_DOMAIN } from '@/constants/urls'
import { axiosInterceptors, env } from '@accor/customer-core'

const axiosSecure = axios.create({
  baseURL: `${ACCOR_SECURE_DOMAIN}`
})

axiosInterceptors.urlInterceptor(axiosSecure, env.generateGetter('secureAccorComApi'))

export default axiosSecure
